// extracted by mini-css-extract-plugin
export var closeButton = "_79-0";